import { hasRisk } from '@utils/helper-utils';

import * as Yup from 'yup';

const requiredText = (isCertificatePolicy: boolean) =>
  isCertificatePolicy
    ? Yup.string().trim().notRequired()
    : Yup.string().trim().required('Required');

export const insuredsValidationSchema = (
  lineCode: string,
  isCertificatePolicy: boolean
) => {
  return Yup.object().shape({
    insureds: Yup.array().of(
      Yup.object().shape({
        id: requiredText(isCertificatePolicy),
        addressId: requiredText(isCertificatePolicy),
        limitOfCover: Yup.string().when([], {
          is: () => hasRisk(lineCode),
          then: () => requiredText(isCertificatePolicy),
          otherwise: (schema) => schema.notRequired().nullable()
        })
      })
    )
  });
};
